/**
 * The error to show when the server says a learner is going too fast (HTTP 429), or null for any other response.
 * The backend sends a plain-language `detail` ("... please try again in N seconds"); fall back to the
 * Retry-After header when the body has none (TR-025).
 */
export async function rateLimitError(
  response: Response
): Promise<Error | null> {
  if (response.status !== 429) {
    return null;
  }
  const body = await response.json().catch(() => null);
  if (body && typeof body.detail === 'string' && body.detail) {
    return new Error(body.detail);
  }
  const retryAfter = response.headers?.get('Retry-After');
  return new Error(
    `You're going a little fast. Please try again in ${retryAfter || 60} seconds.`
  );
}
